var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 30,
    viewBox: "0 0 30 30",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 2.5c.6904 0 1.25.55964 1.25 1.25v.9375h.6968c1.4983 0 2.8576.62761 3.8199 1.64063.0904.09521.0848.24454-.008.33739l-.969.96896c-.1052.10521-.278.09517-.3804-.01281-.6199-.65391-1.4963-1.05917-2.4625-1.05917h-3.8936c-1.7912 0-3.27377 1.39271-3.38559 3.18048l-.27625 4.41682c-.12674 2.0264-.80706 3.9792-1.96687 5.6457-.06298.0905-.06082.2435-.13842.3218l-.99874 1.0079c-.09796.0989-.25921.0995-.34385-.011-.50557-.6601-.59641-1.6161-.05798-2.3897.96383-1.3849 1.52919-3.0078 1.63452-4.6918l.27625-4.41677c.17362-2.77591 2.47563-4.93843 5.25693-4.93843h.6968v-.9375c0-.69036.5596-1.25 1.25-1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m22.2329 10.0929 4.055-4.055c.3661-.36612.3661-.95971 0-1.32583-.3661-.36611-.9597-.36611-1.3258 0l-20.00001 20.00003c-.36612.3661-.36612.9597 0 1.3258.36611.3661.95971.3661 1.32582 0l3.80729-3.8073 1.4673.1761v1.3433c0 1.8985 1.539 3.4375 3.4375 3.4375s3.4375-1.539 3.4375-3.4375v-1.3433l4.2589-.511c1.5137-.1817 2.2889-1.9099 1.4181-3.1612-.9638-1.3849-1.5292-3.0078-1.6345-4.6918zm-1.7681 1.7681-8.6835 8.6835.4178.0502c1.8606.2232 3.7412.2232 5.6018 0l4.6721-.5607c.1094-.0131.1654-.138.1025-.2285-1.1598-1.6665-1.8401-3.6193-1.9669-5.6457zm-5.4648 13.4515c-.863 0-1.5625-.6996-1.5625-1.5625v-.9375h3.125v.9375c0 .8629-.6996 1.5625-1.5625 1.5625z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMute);
export default __webpack_public_path__ + "static/media/icon_mute.bdd2dff264ad65c0f6da75ea198f69b4.svg";
export { ForwardRef as ReactComponent };